import { render, staticRenderFns } from "./HeaderNotice.vue?vue&type=template&id=3ed37c50&scoped=true&"
import script from "./HeaderNotice.vue?vue&type=script&lang=js&"
export * from "./HeaderNotice.vue?vue&type=script&lang=js&"
import style0 from "./HeaderNotice.vue?vue&type=style&index=0&id=3ed37c50&scoped=true&lang=css&"
import style1 from "./HeaderNotice.vue?vue&type=style&index=1&id=3ed37c50&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed37c50",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ed37c50')) {
      api.createRecord('3ed37c50', component.options)
    } else {
      api.reload('3ed37c50', component.options)
    }
    module.hot.accept("./HeaderNotice.vue?vue&type=template&id=3ed37c50&scoped=true&", function () {
      api.rerender('3ed37c50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/header/HeaderNotice.vue"
export default component.exports